var map = {
	"./backoffice.de.locale.json": 4625,
	"./backoffice.el.locale.json": 9355,
	"./backoffice.en.locale.json": 9657,
	"./backoffice.fr.locale.json": 1424,
	"./base.de.locale.json": 6619,
	"./base.el.locale.json": 7837,
	"./base.en.locale.json": 8591,
	"./base.fr.locale.json": 6162,
	"./customerAnalytics.de.locale.json": 5180,
	"./customerAnalytics.el.locale.json": 4346,
	"./customerAnalytics.en.locale.json": 2152,
	"./customerAnalytics.fr.locale.json": 6969,
	"./giftSelection.de.locale.json": 5048,
	"./giftSelection.el.locale.json": 4950,
	"./giftSelection.en.locale.json": 9140,
	"./giftSelection.fr.locale.json": 7645,
	"./services.de.locale.json": 902,
	"./services.el.locale.json": 2876,
	"./services.en.locale.json": 2446,
	"./services.fr.locale.json": 3939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4572;